var React = require('react');
var UrlUtils = require('../../utils/urlUtils');
var Utils = require('../../utils/Utils');
var AppConstants = require('../../constants/AppConstants')
var LoginStore = require('../../stores/LoginStore')
var LocaleUtils = require('../../utils/localeUtils');
var HandleToastr = require('./HandleToastr.js');
var React = require('react');
var ReactIntl = require('react-intl');
var IntlProvider = ReactIntl.IntlProvider;
var ReactToastr = require("react-toastr");
var LoginActions = require('../../actions/LoginActions');
var TranslationsActions = require('../../actions/TranslationsActions');
var {ToastContainer} = ReactToastr;
//var ToastMessageFactory = React.createFactory(ReactToastr.ToastMessage.animation);
var UpdateTitle  = require('../UpdateTitle/UpdateTitle.js');
var GtmLoad = require('../Gtm/GtmLoad.js');
var $ = require('jquery');
var createReactClass = require('create-react-class');

var App = createReactClass({

  displayName: 'App',

  _initializeFromProps(props) {
    if (this.props.client_id && this.props.client_id.length) props.clientId = this.props.client_id[0];
    if (this.props.country_code && this.props.country_code.length) props.countryCode = this.props.country_code[0];
    if (this.props.response_type && this.props.response_type.length) props.responseType = this.props.response_type[0];
    if (this.props.realm_id && this.props.realm_id.length) props.realmId = this.props.realm_id[0];
    if (this.props.redirect_uri && this.props.redirect_uri.length) props.redirectUrl = this.props.redirect_uri[0];
    if (this.props.account_id && this.props.account_id.length) props.accountId = this.props.account_id[0];
    if (this.props.locale_id && this.props.locale_id.length) props.localeId = this.props.locale_id[0];
    if (this.props.user_type && this.props.user_type.length) props.userType = this.props.user_type[0];
    if (this.props.scope && this.props.scope.length) props.scope = this.props.scope[0];
    if (this.props.state && this.props.state.length) props.state = this.props.state[0];
    if (this.props.prompt && this.props.prompt.length) props.prompt = this.props.prompt[0];
    if (this.props.nonce && this.props.nonce.length) props.nonce = this.props.nonce[0];
    if (this.props.code_challenge && this.props.code_challenge.length) props.codeChallenge = this.props.code_challenge[0];
    if (this.props.code_challenge_method && this.props.code_challenge_method.length) props.codeChallengeMethod = this.props.code_challenge_method[0];
    if (this.props.id_token && this.props.id_token.length) props.idToken = this.props.id_token[0];
    if (this.props.id_token && this.props.id_token.length) props.decodedIdToken = this.props.decoded_id_token[0];
    if (this.props.init_session_id && this.props.init_session_id.length) props.init_session_id = this.props.init_session_id[0];
    if (this.props.login_method && this.props.login_method.length) props.login_method = this.props.login_method[0];
  },

  _initializeFromUrlParams(props) {
    props.clientId = UrlUtils.fetchClientIdInfo();
    props.countryCode = UrlUtils.fetchCountryCodeInfo();
    props.responseType = UrlUtils.fetchGrantTypeInfo();
    props.realmId = UrlUtils.fetchRealmIdInfo();
    props.redirectUrl = UrlUtils.fetchRedirectURLInfo();
    props.redirectRawUrl = UrlUtils.fetchRedirectRawURLInfo();
    props.accountId = UrlUtils.fetchAccountIdInfo();
    props.localeId = UrlUtils.fetchLocaleIdInfo();
    props.userType = UrlUtils.fetchUserType();
    props.urlInfo = UrlUtils.fetchURLInfo();
    props.scope = UrlUtils.fetchScopeInfo();
    props.state = UrlUtils.fetchStateInfo();
    props.prompt = UrlUtils.fetchPromptInfo();
    props.nonce = UrlUtils.fetchNonceInfo();
    props.codeChallenge = UrlUtils.fetchCodeChallengeInfo();
    props.codeChallengeMethod = UrlUtils.fetchCodeChallengeMethodInfo();
    props.loginId = UrlUtils.fetchLoginId();
    props.userId = UrlUtils.fetchUserId();
    props.sessionState = UrlUtils.fetchSessionStateInfo();
    props.clientsToBeLogout = UrlUtils.fetchClientsToBeLogoutInfo();
    props.postLogoutRedirectUri = UrlUtils.fetchPostLogoutRedirectUriInfo();
    props.emailSentForgotPassword = UrlUtils.fetchEmailSentForgotPasswordInfo();
    props.channelNotification = UrlUtils.fetchChannelNotificationForgotPasswordInfo();
    props.traceId = UrlUtils.fetchTraceId();
    props.token = UrlUtils.fetchToken();
    props.preview = UrlUtils.fetchPreviewInfo();
    props.decodedIdToken = UrlUtils.fetchDecodedIdToken();
    props.idToken = UrlUtils.fetchIdToken();
    props.initSessionId = UrlUtils.fetchInitSessionIdInfo();
    props.loginMethod = UrlUtils.fetchLoginMethodInfo();

    if (props.urlInfo) {
      props.clientId = props.urlInfo.client_id;
      props.countryCode = props.urlInfo.country_code;
      props.responseType = props.urlInfo.response_type;
      props.redirectUrl = props.urlInfo.redirect_uri;
      props.localeId = props.urlInfo.locale_id;
      props.userType = props.urlInfo.user_type;
      props.accountId = props.urlInfo.account_id;
      props.realmId = props.urlInfo.realm_id;
      props.token = UrlUtils.fetchToken();
      props.scope = UrlUtils.fetchScopeInfo();
      props.state = UrlUtils.fetchStateInfo();
      props.prompt = UrlUtils.fetchPromptInfo();
      props.nonce = UrlUtils.fetchNonceInfo();
      props.loginId = UrlUtils.fetchLoginId();
      props.codeChallenge = UrlUtils.fetchCodeChallengeInfo();
      props.codeChallengeMethod = UrlUtils.fetchCodeChallengeMethodInfo();
      props.emailSentForgotPassword = UrlUtils.fetchEmailSentForgotPasswordInfo(); 
      props.channelNotification = UrlUtils.fetchChannelNotificationForgotPasswordInfo();
      props.idToken = UrlUtils.fetchIdToken();
      props.decodedIdToken = UrlUtils.fetchDecodedIdToken();
      props.initSessionId = UrlUtils.fetchInitSessionIdInfo();
      props.loginMethod = UrlUtils.fetchLoginMethodInfo();  
    }

    props.countryCode = props.countryCode == null ? 'default' : props.countryCode;
    props.realmId = props.realmId == null ? 'default' : props.realmId;
    props.localeId = LoginStore.getLocale(props.localeId, props.countryCode);
    $(document).ajaxError(function (event, jqxhr, settings, thrownError) {
      console.log('An error ' + thrownError + ' was thrown at url ' + settings.url);
    });
    
    return props;
  },
  getInitialState() {
      return {registerCallback:false}
  },
  componentDidMount:function(){
    this.registerCallback();
    const countryCode = UrlUtils.fetchCountryCodeInfo() || AppConstants.DEFAULT_COUNTRY_CODE;
    const realmId = UrlUtils.fetchRealmIdInfo();    
    let localeId = UrlUtils.fetchLocaleIdInfo();      
    localeId = LoginStore.getLocale(localeId, countryCode);  
    LoginActions.getSupportedLocales(realmId, countryCode, localeId);  
    Utils.loadCookieScripts(countryCode);     
    Utils.addHtlmLangAttribute(countryCode.toLowerCase());
    Utils.removeCookies();  
  },

  registerCallback:function(){
      const self = this;
      LoginStore.addToastChangeListener(this.addAlert);
      LoginStore.addGetTranslationsChangeListner(()=>{
        const state = LoginStore.getState();
        self.setState({translations: state.translations});
      });
      LoginStore.addGetSupportedLocalesListner(()=>{
        const state = LoginStore.getState();        
        self.setState({supportedLocales: state.supportedLocales, localeId: state.localeId});
      });
      LoginStore.addGetUserLoginStartegyListner(()=>{
        const state = LoginStore.getState();
        self.setState({allowMobileLogin: state.allowMobileLogin});
      });
      this.setState({registerCallback:true})
  },
  addAlert:function() {
    var iconClassNames = {
          error: "toast-error",
          info: "toast-info",
          success: "toast-success",
          warning: "toast-warning"
    };
    let appState = LoginStore.getState();
    this.refs.container.clear();    
    setTimeout(()=>{
      if(appState.toast.toastType=="success") {
        this.refs.container.success(
            appState.toast.toastMessage, appState.toast.title || '' , {
            timeOut: 9999999999,
            extendedTimeOut: 100000,
            closeButton:true,
            preventOpenDuplicates: true,
            tapToDismiss: true,
            className: "toast",
            iconClassNames: iconClassNames,
            titleClassName: "toast-title",
            messageClassName: "toast-message"
          }
        );
      }
      else if(appState.toast.toastType=="error"){
        this.refs.container.error(
              appState.toast.toastMessage,
              appState.toast.title || '', {
              timeOut: 300000,
              extendedTimeOut: 100000,
              closeButton:true,
              preventOpenDuplicates: true,
              tapToDismiss: true,
              className: "toast",
              iconClassNames: iconClassNames,
              titleClassName: "toast-title",
              messageClassName: "toast-message"
          }
        );
      }
      else if(appState.toast.toastType=="warning"){
        this.refs.container.warning(
              appState.toast.toastMessage,
              appState.toast.title || '', {
              timeOut: 300000,
              extendedTimeOut: 100000,
              closeButton:true,
              preventOpenDuplicates: true,
              tapToDismiss: false,
              className: "toast",
              iconClassNames: iconClassNames,
              titleClassName: "toast-title",
              messageClassName: "toast-message"
          }
        );
      }
    },1000)          
  },

  render: function () {
    LocaleUtils.initLocales();
    let props = {
      clientId: '',
      countryCode: '',
      responseType: '',
      realmId:'',
      redirectUrl: '',
      accountId: '',
      localeId: '',
      userType: '',
      urlInfo: '',      
      scope:'',
      state:'',
      prompt:'',
      nonce:'',
      loginId:'',
      codeChallenge:'',
      codeChallengeMethod:'',
      initSessionId:'',
      loginMethod:''
    };

    props = this.props.realm_id ?
        this._initializeFromProps(props) : this._initializeFromUrlParams(props);

    var PageComponent = Utils.getRequestedPageName(null, props.userType, props.initSessionId, props.loginMethod);    
    return this.state.registerCallback===true && this.state.translations? 
       (     
            <div>
              <ToastContainer ref="container"
                // toastMessageFactory={ToastMessageFactory}
                className="toast-top-full-width" />
              <IntlProvider locale = {props.localeId || this.state.localeId}
                messages = {this.state.translations || {}}>
                <div>
                  <HandleToastr/>
                  <UpdateTitle clientId = {props.clientId}/>
                  <PageComponent {...props} translations={this.state.translations} 
                  supportedLocales = {this.state.supportedLocales} 
                  allowMobileLogin = {this.state.allowMobileLogin}
                  localeId = {this.state.localeId} />
                    <GtmLoad {...props} localeId = {this.state.localeId}/>
                </div>
              </IntlProvider>
          </div>
       ) : (<div></div>)
  }
});

module.exports = App;
